import { useEffect } from "react";

import useAxios from "axios-hooks";

import Loader from "components/loader";
import { getLocalStorage } from "../helperFunctions";
import { API_END_POINTS } from "utils/constants/APIEndPoints";
import { DropDownList } from "utils/types";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import {
  setBranchesAccessDetails,
  setBusinessAllBranches,
  setBusinessBranchesAccess,
} from "store/slices/BusinessBranches";
import { setSelectedBranch } from "store/slices/Dropdown";

export let callBranchesAPI: () => void;

const BusinessBranches = () => {
  const { eatout_id, user_id } = getLocalStorage();

  // API call to get business branches
  const [
    { loading: getBranchesLoading, error: getBranchesError },
    getBranchesAPI,
  ] = useAxios({ ...API_END_POINTS.getAccessBranches }, { manual: true });

  //======================================= useEffect Hooks =======================================//

  // useEffect to handle API error states
  useEffect(() => {
    if (getBranchesError) {
      // notify user
      dispatch(
        openSnackbar({
          open: true,
          message: getBranchesError ? getBranchesError.message : "",
          alert: {
            color: "error",
          },
        })
      );
    }
  }, [getBranchesError]);

  //======================================= Handler Functions =======================================//

  // function to call get branches api
  callBranchesAPI = async () => {
    let branchesList: DropDownList[] = [];

    // get all branches of a business
    const { data } = await getBranchesAPI({
      ...API_END_POINTS.getAccessBranches,
      params: {
        restaurant_id: `${getLocalStorage()?.eatout_id}`,
        admin_id: `${user_id}`,
        source: "biz",
      },
    });

    if (data?.length) {
      branchesList = data.map(
        (branch: { location_address: string; branch_id: string }) => ({
          label: branch.location_address,
          value: branch.branch_id,
        })
      );

      dispatch(setBusinessAllBranches(branchesList));
    }

    // calling branches API to get users accessible branches if business has more than 1 branch
    if (data?.length > 1) {
      const { data } = await getBranchesAPI({
        ...API_END_POINTS.getAccessBranches,
        params: {
          restaurant_id: `${getLocalStorage()?.eatout_id}`,
          admin_id: `${user_id}`,
          uid: `${user_id}`,
          source: "biz",
        },
      });

      if (data?.length) {
        branchesList = data.map(
          (branch: {
            location_address: string;
            branch_id: string;
            email: string;
            phone: string;
            address: string;
          }) => {
            return {
              label: branch.location_address,
              value: branch.branch_id,
            };
          }
        );

        dispatch(
          setBusinessBranchesAccess(
            branchesList.length > 1
              ? [{ label: "All Branches", value: "" }, ...branchesList]
              : branchesList
          )
        );

        // store access branches details
        dispatch(setBranchesAccessDetails(data));
      }
    } else {
      dispatch(setBusinessBranchesAccess(branchesList));

      // store access branches details
      dispatch(setBranchesAccessDetails(data));
    }

    // setting branch-id of branch having access for API payload
    if (branchesList?.length === 1) {
      dispatch(setSelectedBranch([branchesList[0].value]));
    }
  };

  return <>{getBranchesLoading && <Loader />}</>;
};

export default BusinessBranches;
